import { Component, Inject, forwardRef, PLATFORM_ID } from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { CatalogWidgetCheckboxListComponent } from '../checkbox-list/catalog-widget-checkbox-list.component';

@Component({
  selector: 'vc-catalog-widget-short-checkbox-list',
  templateUrl: './catalog-widget-short-checkbox-list.component.html',
  styleUrls: ['./catalog-widget-short-checkbox-list.component.scss']
})
export class CatalogWidgetShortCheckboxListComponent extends CatalogWidgetCheckboxListComponent {
  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    super('CatalogWidgetShortCheckboxListComponent', platformId);
  }
}
